import Human from '@vladmandic/human'

let human: Human
const humanConfig = {
  backend: 'webgl' as const,
  debug: false,
  warmup: 'face' as const,
  modelBasePath: `${process.env.ASSETS_URL || ''}/models/`,
  face: {
    enabled: true,
    detector: {
      rotation: true,
      maxDetected: 1,
    },
    mesh: {
      //needs to be enabled to get yaw value
      enabled: true,
    },
    iris: {
      enabled: false,
    },
    gesture: {
      enabled: false,
    },
    emotion: {
      enabled: false,
    },
    description: {
      enabled: false,
    },
  },
  body: {
    enabled: false,
  },
  hand: {
    enabled: false,
  },
  object: {
    enabled: false,
  },
  gesture: {
    enabled: false,
  },
  segmentation: {
    enabled: false,
  },
}

export const loadHuman = () => {
  human = new Human(humanConfig)

  human.load()

  human.warmup(humanConfig).then(() => {
    console.log('this is config: ' + human.config.backend)
  })
}

export const faceDetection = async (input: HTMLVideoElement) => {
  return await human.detect(input)
}
